<template>
  <div class="loginwarn">
    <label>为方便您购买，请提前登录</label>
    <span>
      <label style="color:#F36F07;padding-right: 10px;">立即登录</label>
      <i class="el-icon-close"></i>
    </span>
  </div>

</template>

<script>
export default {
  name: "loginwarn"
}
</script>

<style scoped>

.loginwarn{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  background: #F7F7F7;
  font-size: 12px;
  color: #666;
}

.loginwarn span{
  display: flex;    align-items: baseline;
  padding-left: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/loginwarn.vue